define('_views/Fan-Single',[
	'text!_templates/fan-single.html'
],
function(
	fanTemplate
) {
	return Backbone.View.extend({
		className: 'spotlight-profile',
		
		template: _.template(fanTemplate),

		events: {
		},

		initialize: function(){
			this.model.on('change', this.render, this);
			this.model.on('destroy', this.remove, this);
		},

		render: function(){
			var model = this.model.toJSON();

			this.$el
				.attr('data-fan-id', model.id)
				.html(
					this.template({
						fan: model
					})
				);

			return this;
		},

		remove: function(){

			if(this.unwrappedChildren !== undefined) {
				this.unwrappedChildren.remove();
			}
 			
 			Backbone.View.prototype.remove.call(this);
		}
		
	});

});

